import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-6" data-testid="not-found-page">
      <div className="text-center max-w-md">
        <h1 className="font-heading text-8xl font-bold text-primary/20">404</h1>
        <h2 className="font-heading text-2xl font-medium mt-4">Page Not Found</h2>
        <p className="text-muted-foreground mt-3 leading-relaxed">
          The page you're looking for doesn't exist or has been moved. Let us help you find what you need.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center mt-8">
          <Link to="/">
            <Button className="rounded-full px-6" data-testid="go-home-btn">
              <Home className="w-4 h-4 mr-2" /> Back to Home
            </Button>
          </Link>
          <Link to="/contact">
            <Button variant="outline" className="rounded-full px-6" data-testid="contact-btn">
              Contact Us
            </Button>
          </Link>
        </div>
        <div className="mt-10 text-sm text-muted-foreground">
          <p>Quick Links:</p>
          <div className="flex flex-wrap gap-3 justify-center mt-2">
            {[{ to: '/products', label: 'Products' }, { to: '/about', label: 'About' }, { to: '/blog', label: 'Blog' }, { to: '/gynecology', label: 'Gynecology' }].map(l => (
              <Link key={l.to} to={l.to} className="text-primary hover:underline">{l.label}</Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
